import imageOne from '@/assets/images/cities/victoria1.jpg'
import imageTwo from '@/assets/images/cities/victoria2.jpg'
import imageThree from '@/assets/images/cities/victoria3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  'city': 'Victoria',
  'writeup': 'Unfortunately our Victoria Location is currently unavailable. Sorry for the inconvenience.',
  'notaries': [
    {
      'name': '',
      'open': false,
      'phone': '',
      'hours': {
        'monday': '',
        'tuesday': '',
        'wednesday': '',
        'thursday': '',
        'friday': '',
        'saturday': '',
        'sunday': ''
      },
      'address': '',
      'notes': ''
    }
  ]
  // 'notaries': [
  //   {
  //     'name': '',
  //     'phone': '',
  //     'hours': {
  //       'monday': '9:00AM to 4:00PM and 7:00PM to 8:30PM',
  //       'tuesday': '9:00AM to 4:00PM and 7:00PM to 8:30PM',
  //       'wednesday': '9:00AM to 4:00PM and 7:00PM to 8:30PM',
  //       'thursday': '9:00AM to 4:00PM and 7:00PM to 8:30PM',
  //       'friday': '9:00AM to 4:00PM and 7:00PM to 8:30PM',
  //       'saturday': 'Closed',
  //       'sunday': 'Closed'
  //     },
  //     'address': 'Alvarado Terrace Location',
  //     'notes': ''
  //   }
  // ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/britishColumbia/cities/victoria.js